import { render, staticRenderFns } from "./pfizer.vue?vue&type=template&id=49d7455a"
import script from "./pfizer.vue?vue&type=script&lang=js"
export * from "./pfizer.vue?vue&type=script&lang=js"
import style0 from "./pfizer.vue?vue&type=style&index=0&id=49d7455a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports